/**
 * Where the browser reaches strike-payer's API from this webapp (no trailing slash).
 *
 * Resolution (first match wins):
 * 1. REACT_APP_STRIKE_PAYER_API_ORIGIN
 * 2. DEV_PAYER_API_ORIGIN_FALLBACK (development builds only)
 * 3. http://localhost:8088 if the page is HTTP (the local dev stack)
 * 4. https://pay.strikepay.co on any HTTPS page — production builds set no REACT_APP_* values
 *    (the hosting build in CI has none), so the live payer is the default, not a null that
 *    makes every screen refuse to call it.
 *
 * Shared by every screen that hands a signed-in person over to strike-payer's OAuth
 * endpoints (Stripe app, AI connections).
 */

/**
 * Development-only: payer public origin when `REACT_APP_STRIKE_PAYER_API_ORIGIN` is unset.
 * Paste your ngrok URL here (no trailing slash) if you do not use `.env.development.local`.
 * Create React App never loads `.env.example`; copy vars into `.env` / `.env.development.local`.
 * Leave empty for default behavior below.
 */
const DEV_PAYER_API_ORIGIN_FALLBACK = '';

/** The live payer, used when a production build has no explicit origin. */
export const PRODUCTION_PAYER_ORIGIN = 'https://pay.strikepay.co';

export function payerApiOrigin() {
  const fromEnv = process.env.REACT_APP_STRIKE_PAYER_API_ORIGIN;
  if (fromEnv && typeof fromEnv === 'string' && fromEnv.trim()) {
    return fromEnv.replace(/\/$/, '');
  }
  if (process.env.NODE_ENV === 'development') {
    const dev = typeof DEV_PAYER_API_ORIGIN_FALLBACK === 'string' && DEV_PAYER_API_ORIGIN_FALLBACK.trim();
    if (dev) {
      return DEV_PAYER_API_ORIGIN_FALLBACK.replace(/\/$/, '');
    }
  }
  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    return PRODUCTION_PAYER_ORIGIN;
  }
  return 'http://localhost:8088';
}

/** Kept for callers that guard on a null origin (none is produced any more); explains the dev setup. */
export const PAYER_ORIGIN_MIXED_CONTENT_MESSAGE = 'strike-payer origin is not set. '
  + 'Set REACT_APP_STRIKE_PAYER_API_ORIGIN in webapp/.env to your payer HTTPS URL (e.g. ngrok for port 8088), restart the dev server, and try again.';

export default payerApiOrigin;
